module.exports = __webpack_public_path__ + "static/media/bg.d7a20f96.jpg";